// src/components/common/CookieConsent.js — Maxula
// Bandeau de consentement RGPD. Tant que l'utilisateur n'a pas accepté, aucun pixel
// marketing (Meta / GA / TikTok) n'est chargé. Bilingue FR/AR (Cairo en RTL).
// react-icons uniquement, aucune emoji. v1.381 — AbodyStudio Limited

import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaCookieBite } from 'react-icons/fa';
import { useLanguage } from '../../i18n/LanguageContext';

const STORAGE_KEY = 'mx_cookie_consent';

const L = {
  fr: {
    text: "Nous utilisons des cookies pour améliorer votre expérience et mesurer notre audience. En acceptant, vous autorisez les cookies de mesure et de marketing.",
    accept: 'Accepter',
    refuse: 'Refuser',
    more: 'En savoir plus'
  },
  ar: {
    text: 'نستخدم ملفات تعريف الارتباط لتحسين تجربتك وقياس جمهورنا. بالقبول، فإنك تسمح بملفات تعريف الارتباط الخاصة بالقياس والتسويق.',
    accept: 'قبول',
    refuse: 'رفض',
    more: 'معرفة المزيد'
  }
};

const setConsent = (value) => {
  try { localStorage.setItem(STORAGE_KEY, value); } catch (e) {}
  try { window.dispatchEvent(new Event('mx-consent-changed')); } catch (e) {}
};

const CookieConsent = () => {
  const { isRTL } = useLanguage();
  const t = isRTL ? L.ar : L.fr;
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const c = localStorage.getItem(STORAGE_KEY);
      if (c !== 'accepted' && c !== 'refused') setVisible(true);
    } catch (e) { setVisible(true); }
  }, []);

  if (!visible) return null;

  const accept = () => { setConsent('accepted'); setVisible(false); };
  const refuse = () => { setConsent('refused'); setVisible(false); };

  return (
    <div
      dir={isRTL ? 'rtl' : 'ltr'}
      style={isRTL ? { fontFamily: "'Cairo', sans-serif" } : undefined}
      className="fixed bottom-0 inset-x-0 z-[60] p-3 sm:p-4"
    >
      <div className="mx-auto max-w-5xl rounded-2xl bg-white shadow-2xl ring-1 ring-gray-200 p-4 sm:p-5 flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4">
        <div className="flex items-start gap-3 flex-1">
          <FaCookieBite className="text-[#e11d7b] mt-0.5 flex-shrink-0" size={24} aria-hidden="true" />
          <p className="text-sm text-gray-700 leading-relaxed">
            {t.text}{' '}
            <Link to="/privacy" className="text-[#e11d7b] font-medium underline">{t.more}</Link>
          </p>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0 w-full sm:w-auto">
          <button
            type="button"
            onClick={refuse}
            className="flex-1 sm:flex-none px-4 py-2 rounded-xl border border-gray-300 text-gray-700 text-sm font-semibold hover:bg-gray-50 transition"
          >
            {t.refuse}
          </button>
          <button
            type="button"
            onClick={accept}
            className="flex-1 sm:flex-none px-5 py-2 rounded-xl bg-[#e11d7b] text-white text-sm font-bold shadow-lg shadow-pink-900/20 hover:-translate-y-0.5 transition"
          >
            {t.accept}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
